import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Checkbox,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import { orderBy } from 'lodash'
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import adminService from "../../../../services/admin.service";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus.svg";
import { ReactComponent as Delete } from "../../../../assets/icons/delete.svg";
import calibrationService from "../../../../services/calibration.service";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const CalibrationTemplateCreate = (props) => {
    const { t } = useTranslation();

    // position: absolute; bottom: -24px
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        fieldsetError: {
            '& div > fieldset': {
                "border-color": "#CC6058"
            }
        },
        disabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },
        input: {
            '& div > input': {
                height: '7px',
                position: "relative"
            }
        },
        inputTopicDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopic: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "4.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopicError: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "4.5px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        selectDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA !important"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div ': {
                padding: "8.05px 14px"
            }
        },
        select: {
            '& div ': {
                padding: "8.05px 14px"
            }
        },
        selectDistribution: {
            '& div ': {
                padding: "4.05px 14px"
            }
        },
        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        TextField: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                    "-webkit-appearance": "none",
                    display: "none"
                }
            },
        },
        width50: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        width100: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        boxInput: {
            ".MuiFormControl-root": {
                "margin-top": "7px"
            }
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycleID } });
    }
    const classes = useStyles();
    let { cycleID } = useParams()
    const [template, setTemplate] = React.useState([]);
    const [evaluate_journey, setEvaluate_journey] = React.useState([{}]);
    const [distribution, setDistribution] = React.useState([{}]);
    const [status, setStatus] = React.useState(true);
    const [onSubmit, setOnSubmit] = React.useState(false);
    const [checkCode, setCheckCode] = React.useState(false);
    const [minMax, setMinMax] = React.useState({});
    const [isFixedDistribution, setIsFixedDistribution] = React.useState(false);

    useEffect(() => {
        calibrationService.getDropdownCalibrationTemplate(cycleID).then((rs) => {
            setTemplate(Util.formatData(rs?.data?.evaluate_journey, []));
        }).catch((err) => {

        })
    }, []);

    let getMinMax = (data) => {
        calibrationService.getMinMax(data).then((rs) => {
            setMinMax(rs?.data)
        })
    }

    const handleStatus = () => {
        setStatus(!status)
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        calibration_component: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        rate_decimal: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            cycle_id: cycleID,
            code: '',
            name: '',
            description: '',
            evaluate_journey_id: [""],
            calibration_component: '',
            rate_decimal: '',
            enable_prorate: false,
            enable_addition_position: false,
            distribution: [{ rating_min: "", rating_max: "", percent: "", description: "" }],
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {

            if (checkData(values) === true) {
                adminService.checkCode("calibration_template", values.code, cycleID).then(
                    (response) => {
                        setCheckCode(response?.data?.is_exist)
                        if (response?.data?.is_exist === false) {
                            submit(values)
                        }
                    },
                ).catch(() => {
                })
            }
        },
    });
    const checkData = (values) => {
        let findDataEvaluate_journey = values.evaluate_journey_id.filter((res) => res === "")
        let findDataDistribution = values.distribution.filter((res) => res?.rating_min === "" || res?.rating_max === "" || res?.percent === "" || res?.description === "")
        if (findDataEvaluate_journey.length > 0 || findDataDistribution.length > 0) {
            return false
        } else {
            if (values.distribution.map(a => Number(a?.percent)).reduce((a, b) => a + b, 0) !== 100) {
                return false
            } else {
                let check = true
                for (let index = 0; index <= values.distribution.length - 1; index++) {
                    if (check) {
                        let valmin = checkValmin(index, values.distribution[index]?.rating_min, values.distribution[index - 1]?.rating_max, values.distribution[index]?.rating_max)
                        let valmax = checkValmax(index, values.distribution[index]?.rating_max, values.distribution[index + 1]?.rating_min, values.distribution[index]?.rating_min)
                        if (valmin !== "" || valmax !== "") {
                            check = false
                        }
                    }
                }
                return check
            }
        }
    }
    const checkDataOne = (data) => {
        let findData = data.filter((res) => res.topic !== "" && res.answer_type !== "")
        if (findData !== undefined && findData.length > 0 && findData.length === data.length) {
            return true;
        }
        return false;
    }

    const handleSubmit = () => {
        formik.submitForm()
        setOnSubmit(true)
    }
    const addEvaluate_journey = () => {
        setEvaluate_journey([...evaluate_journey, {}])
        formik.setFieldValue("evaluate_journey_id", [...formik.values.evaluate_journey_id, ""])
    }
    const addDistribution = (rating_min = '', rating_max = "", percent = "", description = "") => {
        setDistribution([...distribution, {}])
        formik.setFieldValue("distribution", [...formik.values.distribution, { rating_min: '', rating_max: '', percent: '', description: '' }])
    }

    const formikChange = (val, field, subField, index, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = { ...formik.values[field][index], [subField]: val.target.value }
        formik.setFieldValue(field, data[field])
    }
    const formikChangeNumber = (val, field, subField, index, type) => {
        const regex = /[^0-9]/g;
        const regexD = /[^0-9.]/g;
        const found = val.target.value.match(type === "decimal" ? regexD : regex);
        let indexof = val.target.value.indexOf(".")
        let lastIndexof = val.target.value.lastIndexOf(".")
        let dm = (val.target.value.length - 1) - lastIndexof
        if (found !== null || val.target.value === "." || indexof !== lastIndexof) {

        } else if (type === "decimal" && indexof > 0 && indexof !== val.target.value.length - 1) {
            if (dm <= formik.values.rate_decimal) {
                let data = JSON.parse(JSON.stringify(formik.values))
                data[field][index] = { ...formik.values[field][index], [subField]: val.target.value }
                formik.setFieldValue(field, data[field])
            }
        } else {
            let data = JSON.parse(JSON.stringify(formik.values))
            data[field][index] = { ...formik.values[field][index], [subField]: val.target.value }
            formik.setFieldValue(field, data[field])
        }
    }
    const formikChanges = (val, field, index) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = val.target.value

        formik.setFieldValue(field, data[field])
    }
    const formikDelete = (dataLoop, field, setData, index) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let dataShow = JSON.parse(JSON.stringify(dataLoop))
        data[field].splice(index, 1)
        dataShow.splice(index, 1)
        setData(dataShow)
        formik.setFieldValue(field, data[field])
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }
    const getDate = (data, field) => {
        return Util.formatDate2(data?.options?.[field]?.start_at) + `${Util.formatData(Util.formatDate2(data?.options?.[field]?.start_at), false) === false || Util.formatData(Util.formatDate2(data?.options?.[field]?.end_at), false) === false ? "" : " - "}` + Util.formatDate2(data?.options?.[field]?.end_at)
    }
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        openDialog(false);
        navigate('/admin/calibration-template', { replace: false, state: { cycleID: cycleID } });
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/calibration-template', { replace: false, state: { cycleID: cycleID } });
    }
    const submit = (data) => {
        let dataAddSeq = JSON.parse(JSON.stringify(data))
        if (Util.formatData(dataAddSeq?.distribution, []).length > 0) {
            for (let index = 0; index <= dataAddSeq.distribution.length - 1; index++) {
                dataAddSeq.distribution[index].seq = index + 1
                dataAddSeq.distribution[index].rating_min = Number(dataAddSeq.distribution[index].rating_min)
                dataAddSeq.distribution[index].rating_max = Number(dataAddSeq.distribution[index].rating_max)
                dataAddSeq.distribution[index].percent = Number(dataAddSeq.distribution[index].percent)
            }
        }
        dataAddSeq.status = status ? "active" : "inactive"
        calibrationService.createCalibrationTemplate(dataAddSeq).then((rs) => {
            openSuccessAddDialog(true)
        }).catch((err) => {
        })
    }

    useEffect(() => {
        if (checkCode === true) {
            setCheckCode(false)
        }
    }, [formik.values.code]);

    useEffect(() => {
        getMinMax({ evaluate_journey_id: formik.values.evaluate_journey_id })
    }, [formik.values.evaluate_journey_id]);

    useEffect(() => {

        if (minMax?.configuration?.fill_grade?.grades) {
            const grades = minMax?.configuration?.fill_grade?.grades

            const min_value = (minMax?.max > 0) ? parseInt(minMax?.min) : 1
            const max_value = (minMax?.max > 0) ? parseInt(minMax?.max) : grades.length

            let rangeGrade = calculateDistributionRange(min_value, max_value, grades.length)
            rangeGrade = orderBy(rangeGrade, ['min'], ['desc'])

            let current_distribution = []
            let form_distribution = []// formik.values.distribution
            for (let i = 0, ii = grades.length; i < ii; i++) {
                const grade = grades[i]
                const this_range = rangeGrade[i]

                current_distribution.push({})
                form_distribution.push({ rating_min: this_range.min, rating_max: this_range.max, percent: '', description: grade })
            }

            form_distribution = orderBy(form_distribution, ['rating_min'], ['asc'])

            setDistribution(current_distribution)
            formik.setFieldValue("distribution", form_distribution)
            setIsFixedDistribution(true)


        }


    }, [minMax])

    const calculateDistributionRange = (min, max, numRanges = 5) => {
        const ranges = [];
        const rangeSize = (max - min) / numRanges;

        for (let i = 0; i < numRanges; i++) {
            const start = min + i * rangeSize;
            const end = start + rangeSize;
            ranges.push({
                min: start.toFixed(2),
                max: ((numRanges - 1 == i) ? max : end - 0.01).toFixed(2)
            });
        }

        return ranges;
    }

    let checkValmin = (index, val, beforeVal, maxValCheck) => {
        let check = ""
        let min = Util.formatData(val, 0)
        let max = Util.formatData(maxValCheck, 0)
        let vCheck = Util.formatData(beforeVal, 0)
        if (index === 0) {
            if (Util.formatData(val, false) === false) {
                check = "emty"
            } else {
                if (Util.formatData(minMax?.is_found, false) !== false && Util.formatData(minMax?.min, false) !== false) {
                    if (Number(min) < Number(minMax?.min)) {
                        return "overScale"
                    }
                }
            }
        } else {
            if (Util.formatData(val, false) === false) {
                check = "emty"
            } else {
                if (Util.formatData(minMax?.is_found, false) !== false && Util.formatData(minMax?.min, false) !== false) {
                    if (Number(min) < Number(minMax?.min)) {
                        return "overScale"
                    }
                }
                if (Number(min) > Number(max) || Number(max) < Number(min) || Number(vCheck) >= Number(min)) {
                    check = "over"
                } else {
                    let rate_decimal = Util.formatData(formik.values.rate_decimal, 0)
                    if (rate_decimal === 0) {
                        let sumMin = Number(vCheck) + 1
                        if (Number(min) !== Number(sumMin.toFixed(rate_decimal))) {
                            return "over"
                        }
                    } else {
                        let gap = 1 / (10 ** rate_decimal)
                        let sumMin = Number(vCheck) + gap
                        if (Number(min) !== Number(sumMin.toFixed(rate_decimal))) {
                            return "over"
                        }
                    }
                }
            }
        }
        return check
    }

    let checkValmax = (index, maxVal, valCheck, minVal) => {
        let check = ""
        let min = Util.formatData(minVal, 0)
        let max = Util.formatData(maxVal, 0)
        let vCheck = Util.formatData(valCheck, 0)
        if (index === 0) {
            if (Util.formatData(maxVal, false) === false) {
                return "emty"
            } else {
                if (Util.formatData(minMax?.is_found, false) !== false && Util.formatData(minMax?.max, false) !== false) {
                    if (Number(maxVal) > Number(minMax?.max)) {
                        return "overScale"
                    }
                }
                if (distribution.length - 1 !== index) {
                    if (Number(min) > Number(max) || Number(max) < Number(min) || Number(max) >= Number(vCheck)) {
                        return "over"
                    } else {
                        let rate_decimal = Util.formatData(formik.values.rate_decimal, 0)
                        if (rate_decimal === 0) {
                            let sumMin = Number(max) + 1
                            if (Number(vCheck) !== Number(sumMin.toFixed(rate_decimal))) {
                                return "over"
                            }
                        } else {
                            let gap = 1 / (10 ** rate_decimal)
                            let sumMin = Number(max) + gap
                            if (Number(vCheck) !== Number(sumMin.toFixed(rate_decimal))) {
                                return "over"
                            }
                        }
                    }
                } else {
                    if (Number(min) > Number(max) || Number(max) < Number(min)) {
                        return "over"
                    }
                }
            }
        } else {
            if (Util.formatData(maxVal, false) === false) {
                return "emty"
            } else {
                if (Util.formatData(minMax?.is_found, false) !== false && Util.formatData(minMax?.max, false) !== false) {
                    if (Number(maxVal) > Number(minMax?.max)) {
                        return "overScale"
                    }
                }
                if (distribution.length - 1 !== index) {
                    if (Number(min) > Number(max) || Number(max) < Number(min) || Number(max) >= Number(vCheck)) {
                        return "over"
                    } else {
                        let rate_decimal = Util.formatData(formik.values.rate_decimal, 0)
                        if (rate_decimal === 0) {
                            let sumMin = Number(max) + 1
                            if (Number(vCheck) !== Number(sumMin.toFixed(rate_decimal))) {
                                return "over"
                            }
                        } else {
                            let gap = 1 / (10 ** rate_decimal)
                            let sumMin = Number(max) + gap
                            if (Number(vCheck) !== Number(sumMin.toFixed(rate_decimal))) {
                                return "over"
                            }
                        }
                    }
                } else {
                    if (Number(min) > Number(max) || Number(max) < Number(min)) {
                        return "over"
                    }
                }
            }
        }
        return check
    }

    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/calibration-template')}>Calibration Template</span> / <span style={styles.end} >Create Calibration Template</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" color="#404349" fontSize={36} lineHeight="53.82px" fontWeight="500">
                                Create Calibration Template
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                <Paper sx={{ padding: "40px 40px 20px", "box-shadow": " 0px 2px 10px rgba(0, 0, 0, 0.1)", "border-radius": "10px", width: '100%' }} classes={{ root: classes.error }}>
                                    <Box display="flex" sx={{ margin: "0 -40px", flexFlow: "row wrap" }}>
                                        <Box sx={{ width: "calc(50% - 80px)", position: "relative", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} >
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.code')} <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code) === false ? checkCode === true ? true : false : true}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder="Fill the calibration template code"
                                                classes={{ root: classes.input }}
                                            />
                                            {Boolean(formik.touched.code && formik.errors.code) === false && checkCode === true ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('label.alreadyUsed')}</FormHelperText>) : <></>}
                                        </Box>
                                        <Box sx={{ width: "calc(50% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.status')} <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                            <Box sx={{ "margin-top": "7px", height: "41px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0, ".MuiTypography-root": { color: "#404349" } }}
                                                        control={<IOSSwitch checked={status} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box> *</Box></Typography> */}
                                            </Box>
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.name')} <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.name && formik.errors.name)}
                                                fullWidth
                                                helperText={formik.touched.name && formik.errors.name}
                                                margin="normal"
                                                name="name"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.name}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder="Fill the calibration template name"
                                                classes={{ root: classes.input }}
                                            />
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px" }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Form Calibration Template <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                            <Box sx={{ position: "relative" }}>
                                                <Box mt="10px" sx={{ border: "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                    <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                        <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">MANAGE FORM CALIBRATION TEMPLATE</Typography>
                                                        <Box onClick={addEvaluate_journey} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                            <PlusIcon />
                                                            <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">
                                                                {/* {t('label.add')} */}
                                                                Add
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ overflow: "hidden", height: "100%", transition: "all .8s", "max-height": evaluate_journey !== undefined && evaluate_journey !== null && evaluate_journey.length > 0 ? "999999px" : "0px" }}>
                                                        {evaluate_journey !== undefined && evaluate_journey !== null && evaluate_journey.length > 0 ?
                                                            <Box pb="16px">
                                                                <Box sx={{ width: "100%", background: "#FAFAFA", }} mt="16px">
                                                                    <Divider />
                                                                    <Box sx={{ height: "48px", padding: "0 25px", display: "flex", "align-items": "center" }}>
                                                                        <Box sx={{ width: "calc(50% - 22.5px)" }}>
                                                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Template</Typography>
                                                                        </Box>
                                                                        <Box sx={{ width: "calc(50% - 22.5px)" }}>
                                                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Form Detail</Typography>
                                                                        </Box>
                                                                        <Box sx={{ width: "45px" }}></Box>
                                                                    </Box>
                                                                    <Divider />
                                                                </Box>
                                                                {evaluate_journey.map((item, orders) => (
                                                                    <Box sx={{ width: "100%" }} >
                                                                        <Box sx={{ minHeight: "49px", padding: "0 25px", display: "flex", }}>
                                                                            <Box sx={{ width: "calc(50% - 22.5px)" }} py="15px" pr="40px">
                                                                                <Select
                                                                                    variant="outlined"
                                                                                    defaultValue=""
                                                                                    displayEmpty
                                                                                    size="small"
                                                                                    fullWidth
                                                                                    // disabled={item.edit === false ? true : false}selectError
                                                                                    className="white-bg"
                                                                                    error={onSubmit === true && Util.formatData(formik.values.evaluate_journey_id[orders], false) === false}
                                                                                    onChange={e => formikChanges(e, "evaluate_journey_id", orders)}
                                                                                    value={formik.values.evaluate_journey_id[orders]}
                                                                                    MenuProps={{ autoFocus: false, }}
                                                                                    classes={{ root: classes.select }}
                                                                                >
                                                                                    <MenuItem disabled value="" sx={{ display: "none" }}>
                                                                                        <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select the template</Typography>
                                                                                    </MenuItem>
                                                                                    {template.length > 0 ?
                                                                                        template.map(dt => {
                                                                                            return (
                                                                                                <MenuItem value={dt.serial} key={dt.serial} sx={{ display: formik.values.evaluate_journey_id.filter((rs) => rs === dt.serial).length > 0 ? formik.values.evaluate_journey_id[orders] === dt.serial ? "" : "none" : "" }}>
                                                                                                    <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{dt?.code} - {dt?.name}</span>
                                                                                                </MenuItem>
                                                                                            )
                                                                                        })
                                                                                        :
                                                                                        null
                                                                                    }
                                                                                </Select>
                                                                                {onSubmit === true && Util.formatData(formik.values.evaluate_journey_id[orders], false) === false ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                                                            </Box>
                                                                            {Object.keys(Util.formatData(template.find((rs) => rs?.serial === formik.values.evaluate_journey_id[orders]), [])).length > 0 ?
                                                                                <Box sx={{ width: "calc(50% - 22.5px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }} pt="11px">
                                                                                    <Box sx={{ display: "flex" }}>
                                                                                        <Typography width="110px" fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" >
                                                                                            Cycle Date:
                                                                                        </Typography>
                                                                                        <Typography width="calc(100% - 110px)" fontWeight="400" color="#404349" fontSize={16} lineHeight="23.92px" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} >
                                                                                            {getDate(template.find((rs) => rs?.serial === formik.values.evaluate_journey_id[orders]), "cycle")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                    <Box sx={{ display: "flex" }}>
                                                                                        <Typography width="110px" fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" >
                                                                                            Evaluate Date:
                                                                                        </Typography>
                                                                                        <Typography width="calc(100% - 110px)" fontWeight="400" color="#404349" fontSize={16} lineHeight="23.92px" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                                                            {getDate(template.find((rs) => rs?.serial === formik.values.evaluate_journey_id[orders]), "evaluate")}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                                :
                                                                                <Box sx={{ width: "calc(50% - 22.5px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }} pt="24px" pr="40px">
                                                                                    <Box sx={{ display: "flex" }}>
                                                                                        <Typography width="110px" fontWeight="400" color="#AAAAAA" fontSize={16} lineHeight="23.92px" >
                                                                                            -
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                            }
                                                                            {orders === 0 ?
                                                                                <Box sx={{ width: "45px", "padding-left": "25px", height: "20px" }} mt="25px">
                                                                                    <Delete style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                                                                </Box>
                                                                                :
                                                                                <Box sx={{ width: "45px", "padding-left": "25px", height: "20px" }} mt="25px">
                                                                                    <Delete style={{ cursor: "pointer" }} onClick={e => formikDelete(evaluate_journey, "evaluate_journey_id", setEvaluate_journey, orders)} />
                                                                                </Box>
                                                                            }
                                                                        </Box>
                                                                        <Divider />
                                                                    </Box>
                                                                ))
                                                                }
                                                            </Box>
                                                            :
                                                            null
                                                        }
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box pt="30px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", }} display="flex">
                                            <Box width="50%" pr="40px" sx={{ position: "relative", ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }}>
                                                <Typography fontWeight="500" color="#404349" pb="7px" fontSize={18} lineHeight="23.92px" display="flex">Calibration Component <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>

                                                {minMax?.configuration?.fill_grade?.grades ? (
                                                    <Select
                                                        id="calibration_component"
                                                        name="calibration_component"
                                                        variant="outlined"
                                                        defaultValue=""
                                                        displayEmpty
                                                        size="small"
                                                        error={Boolean(formik.touched.calibration_component && formik.errors.calibration_component)}
                                                        fullWidth
                                                        className="white-bg"
                                                        onChange={formik.handleChange}
                                                        value={formik.values.calibration_component}
                                                        classes={{ root: classes.select }}
                                                    >
                                                        <MenuItem disabled value="" key="0" sx={{ display: "none" }}>
                                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select calibration component</Typography>
                                                        </MenuItem>

                                                        <MenuItem value="evaluate" key="1" >
                                                            <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Final Grade</span>
                                                        </MenuItem>

                                                        <MenuItem value="latest_grade" key="2" >
                                                            <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>All Latest Grade</span>
                                                        </MenuItem>

                                                    </Select>
                                                ) : (
                                                    <Select
                                                        id="calibration_component"
                                                        name="calibration_component"
                                                        variant="outlined"
                                                        defaultValue=""
                                                        displayEmpty
                                                        size="small"
                                                        error={Boolean(formik.touched.calibration_component && formik.errors.calibration_component)}
                                                        fullWidth
                                                        className="white-bg"
                                                        onChange={formik.handleChange}
                                                        value={formik.values.calibration_component}
                                                        classes={{ root: classes.select }}
                                                    >
                                                        <MenuItem disabled value="" key="0" sx={{ display: "none" }}>
                                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select calibration component</Typography>
                                                        </MenuItem>

                                                        <MenuItem value="evaluate" key="1" >
                                                            <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Total Score</span>
                                                        </MenuItem>
                                                        <MenuItem value="goal" key="2" >
                                                            <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Goal</span>
                                                        </MenuItem>
                                                        <MenuItem value="competency" key="3" >
                                                            <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Competency</span>
                                                        </MenuItem>

                                                    </Select>
                                                )}


                                                {onSubmit === true && Boolean(formik.touched.calibration_component && formik.errors.calibration_component) ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                            </Box>
                                            <Box width="50%" pl="40px" sx={{ position: "relative", ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }}>
                                                <Typography fontWeight="500" color="#404349" pb="7px" fontSize={18} lineHeight="23.92px" display="flex">Decimal <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                                <Select
                                                    id="rate_decimal"
                                                    name="rate_decimal"
                                                    variant="outlined"
                                                    defaultValue=""
                                                    displayEmpty
                                                    size="small"
                                                    error={Boolean(formik.touched.rate_decimal && formik.errors.rate_decimal)}
                                                    fullWidth
                                                    helperText={formik.touched.rate_decimal && formik.errors.rate_decimal}
                                                    className="white-bg"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.rate_decimal}
                                                    classes={{ root: classes.select }}
                                                >
                                                    <MenuItem disabled value='' key="0" sx={{ display: "none" }}>
                                                        <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select decimal</Typography>
                                                    </MenuItem>
                                                    <MenuItem value={0} key="1" >
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>0</span>
                                                    </MenuItem>
                                                    <MenuItem value={1} key="2" >
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>1</span>
                                                    </MenuItem>
                                                    <MenuItem value={2} key="3" >
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>2</span>
                                                    </MenuItem>
                                                    <MenuItem value={3} key="4" >
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>3</span>
                                                    </MenuItem>
                                                    <MenuItem value={4} key="5" >
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>4</span>
                                                    </MenuItem>
                                                </Select>
                                                {onSubmit === true && Boolean(formik.touched.rate_decimal && formik.errors.rate_decimal) ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                            </Box>
                                        </Box>
                                        <Box pt="30px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", position: "relative" }}>
                                            <Box sx={{ display: "flex", pb: "25px", ".MuiCheckbox-root": { p: 0, display: "block", height: "24px" } }}>
                                                <Checkbox checked={formik.values.enable_prorate} onChange={e => formik.setFieldValue("enable_prorate", !formik.values.enable_prorate)} label={t('competency.notEvaluated')} />
                                                <Box>
                                                    <Typography pl="10px" fontWeight="400" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">
                                                        Enable Prorate
                                                    </Typography>
                                                    <Typography pl="10px" fontWeight="400" color="#AAAAAA" fontSize={16} lineHeight="23.92px" display="flex">
                                                        For employee with more than 1 form, score calculation based on period of time.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: "flex", pb: "25px", ".MuiCheckbox-root": { p: 0, display: "block", height: "24px" } }}>
                                                <Checkbox checked={formik.values.enable_addition_position} onChange={e => formik.setFieldValue("enable_addition_position", !formik.values.enable_addition_position)} label={t('competency.notEvaluated')} />
                                                <Box>
                                                    <Typography pl="10px" fontWeight="400" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">
                                                        Enable Additional Position
                                                    </Typography>
                                                    <Typography pl="10px" fontWeight="400" color="#AAAAAA" fontSize={16} lineHeight="23.92px" display="flex">
                                                        For employee with more than 1 form, score calculation based on assignment ratio.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Typography fontWeight="500" color="#404349" pb="7px" fontSize={18} lineHeight="23.92px" display="flex">Distribution (%) Guideline <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                            <Box mt="10px" sx={{ border: "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>

                                                {!isFixedDistribution &&
                                                    <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                        <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>MANAGE DISTRIBUTION (%) GUIDELINE <span style={{ fontWeight: "400", color: "#AAAAAA", fontSize: "14px", marginLeft: "5px" }}>(Create guideline in ascending order by rating value.)</span></Typography>
                                                        <Box onClick={addDistribution} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }} >
                                                            <PlusIcon />
                                                            <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">
                                                                {/* {t('label.add')} */}
                                                                Add
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                }

                                                {distribution !== undefined && distribution !== null && distribution.length > 0 ?
                                                    <Box pb="16px">
                                                        <Box sx={{ width: "100%", background: "#FAFAFA", }} mt="16px">
                                                            <Divider />
                                                            <Box sx={{ height: "48px", padding: "0 25px", display: "flex", "align-items": "center" }}>
                                                                <Box sx={{ width: "55px" }}>
                                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Group</Typography>
                                                                </Box>
                                                                <Box sx={{ width: "calc(100% - 535px)" }}>
                                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Description <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                                                </Box>

                                                                {!isFixedDistribution &&
                                                                    <Box sx={{ width: "270px" }}>
                                                                        <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Evaluation Result <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                                                    </Box>
                                                                }
                                                                <Box sx={{ width: "165px" }}>
                                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Guideline <span style={{ color: "#CC6058", marginLeft: "5px" }}> *</span></Typography>
                                                                </Box>
                                                                <Box sx={{ width: "45px" }}></Box>
                                                            </Box>
                                                            <Divider />
                                                        </Box>
                                                        {distribution.map((item, orders) => (
                                                            <Box sx={{ width: "100%" }} >
                                                                <Box sx={{ minHeight: "49px", padding: "0 25px", display: "flex", }}>
                                                                    <Box sx={{ width: "55px" }}>
                                                                        <Typography color="#404349" pt="13px" fontWeight="400" fontSize={16} lineHeight="23.92px" >{orders + 1}</Typography>
                                                                    </Box>
                                                                    <Box sx={{ width: "calc(100% - 535px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }} py="8.5px" pr="40px">
                                                                        <TextField
                                                                            error={onSubmit === true && Util.formatData(formik.values.distribution[orders].description, false) === false}
                                                                            fullWidth
                                                                            // helperText={formik.touched.name && formik.errors.name}
                                                                            margin="normal"
                                                                            name="topic"
                                                                            onBlur={formik.handleBlur}
                                                                            onChange={e => formikChange(e, "distribution", "description", orders)}
                                                                            type="text"
                                                                            value={formik.values.distribution[orders]?.description}
                                                                            variant="outlined"
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            multiline
                                                                            sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                                            placeholder="Fill description"
                                                                            classes={{ root: classes.inputTopic }}
                                                                            disabled={isFixedDistribution}
                                                                        />
                                                                        {onSubmit === true && Util.formatData(formik.values.distribution[orders].description, false) === false ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                                                    </Box>
                                                                    <Box sx={{ width: "270px", '.MuiOutlinedInput-root': { "padding": "0px !important" }, display: isFixedDistribution ? 'none' : '' }} py="8.5px" pr="40px">
                                                                        <Box>
                                                                            <Box display="flex" justifyContent="space-between">
                                                                                <TextField
                                                                                    // checkValmin = (index, val, beforeVal, maxValCheck) => {
                                                                                    error={onSubmit === true ? checkValmin(orders, formik.values.distribution[orders]?.rating_min, formik.values.distribution[orders - 1]?.rating_max, formik.values.distribution[orders]?.rating_max) !== "" : false}
                                                                                    fullWidth
                                                                                    // helperText={formik.touched.name && formik.errors.name}
                                                                                    margin="normal"
                                                                                    name="description"
                                                                                    onBlur={formik.handleBlur}
                                                                                    onChange={e => formikChangeNumber(e, "distribution", "rating_min", orders, "decimal")}
                                                                                    type="text"
                                                                                    value={formik.values.distribution[orders]?.rating_min}
                                                                                    variant="outlined"
                                                                                    InputLabelProps={{
                                                                                        shrink: true,
                                                                                    }}
                                                                                    sx={{ ".MuiOutlinedInput-root": { color: "#404349", }, width: "100px", ".MuiOutlinedInput-input": { padding: "4.5px 9px", textAlign: "center" } }}
                                                                                    placeholder="Fill Amount"
                                                                                    classes={{ root: classes.TextField }}
                                                                                />
                                                                                <Typography color="#404349" pt="5px" fontWeight="400" fontSize={16} lineHeight="23.92px" >-</Typography>
                                                                                <TextField
                                                                                    // checkValmax = (index, maxVal, valCheck, minVal)
                                                                                    error={onSubmit === true ? checkValmax(orders, formik.values.distribution[orders]?.rating_max, formik.values.distribution[orders + 1]?.rating_min, formik.values.distribution[orders]?.rating_min) !== "" : false}
                                                                                    fullWidth
                                                                                    // helperText={formik.touched.name && formik.errors.name}
                                                                                    margin="normal"
                                                                                    name="description"
                                                                                    onBlur={formik.handleBlur}
                                                                                    onChange={e => formikChangeNumber(e, "distribution", "rating_max", orders, "decimal")}
                                                                                    type="text"
                                                                                    value={formik.values.distribution[orders]?.rating_max}
                                                                                    variant="outlined"
                                                                                    InputLabelProps={{
                                                                                        shrink: true,
                                                                                    }}
                                                                                    sx={{ ".MuiOutlinedInput-root": { color: "#404349", }, width: "100px", ".MuiOutlinedInput-input": { padding: "4.5px 9px", textAlign: "center" } }}
                                                                                    placeholder="Fill Amount"
                                                                                    classes={{ root: classes.TextField }}
                                                                                />
                                                                            </Box>
                                                                            {onSubmit === true ?
                                                                                Util.formatData(formik.values.distribution[orders]?.rating_min, false) === false || Util.formatData(formik.values.distribution[orders]?.rating_max, false) === false ?
                                                                                    (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>)
                                                                                    :
                                                                                    checkValmin(orders, formik.values.distribution[orders]?.rating_min, formik.values.distribution[orders - 1]?.rating_max, formik.values.distribution[orders]?.rating_max) !== "" ||
                                                                                        checkValmax(orders, formik.values.distribution[orders]?.rating_max, formik.values.distribution[orders + 1]?.rating_min, formik.values.distribution[orders]?.rating_min) !== "" ?
                                                                                        (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{checkValmin(orders, formik.values.distribution[orders]?.rating_min, formik.values.distribution[orders - 1]?.rating_max, formik.values.distribution[orders]?.rating_max) === "overScale" || checkValmax(orders, formik.values.distribution[orders]?.rating_max, formik.values.distribution[orders + 1]?.rating_min, formik.values.distribution[orders]?.rating_min) === "overScale" ? "The value is over scale." : "The value is invalid."}</FormHelperText>)
                                                                                        : <></>
                                                                                : null}
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ width: "165px", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }} py="8.5px" >
                                                                        <Box display="flex">
                                                                            <TextField
                                                                                error={onSubmit === true ? Util.formatData(formik.values.distribution[orders].percent, false) === false ? true : formik.values.distribution.map(a => Number(a?.percent)).reduce((a, b) => a + b, 0) === 100 ? false : true : false}
                                                                                fullWidth
                                                                                // helperText={formik.touched.name && formik.errors.name}
                                                                                margin="normal"
                                                                                name="description"
                                                                                onBlur={formik.handleBlur}
                                                                                onChange={e => formikChangeNumber(e, "distribution", "percent", orders,)}
                                                                                type="text"
                                                                                value={formik.values.distribution[orders]?.percent}
                                                                                variant="outlined"
                                                                                InputLabelProps={{
                                                                                    shrink: true,
                                                                                }}
                                                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", }, width: "100px", ".MuiOutlinedInput-input": { padding: "4.5px 9px", textAlign: "center" } }}
                                                                                placeholder="Fill Amount"
                                                                                classes={{ root: classes.TextField }}
                                                                            />
                                                                            <Typography pl="10px" color="#404349" pt="5px" fontWeight="400" fontSize={16} lineHeight="23.92px" >%</Typography>
                                                                        </Box>
                                                                        {onSubmit === true ? Util.formatData(formik.values.distribution[orders].percent, false) === false ? <FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText> : null : null}
                                                                    </Box>
                                                                    {(orders === 0 || isFixedDistribution) ?
                                                                        <Box sx={{ width: "45px", "padding-left": "25px", height: "20px" }} mt="15px">
                                                                            <Delete style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                                                        </Box>
                                                                        :
                                                                        <Box sx={{ width: "45px", "padding-left": "25px", height: "20px" }} mt="15px">
                                                                            <Delete style={{ cursor: "pointer" }} onClick={e => formikDelete(distribution, "distribution", setDistribution, orders)} />
                                                                        </Box>
                                                                    }
                                                                </Box>
                                                                <Divider />
                                                            </Box>
                                                        ))
                                                        }
                                                        <Box>
                                                            <Typography pr="113px" pt="15px" textAlign="end" fontSize={16} lineHeight="26.91px" fontWeight="400" color="#404349">Total:  <span style={{ fontSize: "18px", lineHeight: "23.92px", fontWeight: "500", paddingLeft: "5px", color: formik.values.distribution.map(a => Number(a?.percent)).reduce((a, b) => a + b, 0) === 100 ? "#5DA196" : formik.values.distribution.map(a => Number(a?.percent)).reduce((a, b) => a + b, 0) === 0 ? "#D8D8D8" : "#CC6058" }}>{formik.values.distribution.map(a => Number(a?.percent)).reduce((a, b) => a + b, 0)}  %</span></Typography>
                                                        </Box>
                                                    </Box>
                                                    :
                                                    null
                                                }
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box mt="30px">
                                        <Box display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                    {/* {t('label.create')} */}
                                                    <Typography fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">Create</Typography>
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                    <Typography fontSize={18} lineHeight="29px" fontWeight="500" color="#6B6B6B">Cancel</Typography>
                                                    {/* {t('label.cancel')} */}
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text="Calibration Template was created"
                        page={true}
                    />
                    {/* <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title="ดำเนินการไม่สำเร็จ"
                        text={errorText + " \nใหม่อีกครั้ง"}
                    /> */}
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                </Container>
            </Box >
        </>
    )
};
export default CalibrationTemplateCreate;
